'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import MomentumBadge from '@/components/ui/MomentumBadge';
import FitScoreBadge from '@/components/ui/FitScoreBadge';
import Icon from '@/components/ui/AppIcon';

const shortlisted = [
{
  id: 'sl-yasmine', name: 'Yasmine Belkacem', handle: '@yasmine.create', category: 'Lifestyle · Beauty',
  momentum: 94, fitScore: 94, followers: '284K', engagement: 8.7, available: true,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17c51f72e-1772730442180.png",
  avatarAlt: 'Yasmine Belkacem creator photo'
},
{
  id: 'sl-amel', name: 'Amel Bensalem', handle: '@amel.bensalem', category: 'Beauty',
  momentum: 88, fitScore: 91, followers: '156K', engagement: 9.1, available: true,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17cd9a417-1763300766919.png",
  avatarAlt: 'Amel Bensalem creator photo'
},
{
  id: 'sl-karim', name: 'Karim Oussedik', handle: '@karim.tech', category: 'Tech',
  momentum: 79, fitScore: 77, followers: '94K', engagement: 5.9, available: true,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_184e5f4b2-1763294080263.png",
  avatarAlt: 'Karim Oussedik creator photo'
},
{
  id: 'sl-lina', name: 'Lina Meziane', handle: '@lina.beauty', category: 'Beauty · Fashion',
  momentum: 91, fitScore: 84, followers: '317K', engagement: 9.4, available: false,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c4ca469f-1774431858307.png",
  avatarAlt: 'Lina Meziane creator photo'
},
{
  id: 'sl-sarah', name: 'Sarah Hamdi', handle: '@sarah.h', category: 'Lifestyle',
  momentum: 87, fitScore: 84, followers: '182K', engagement: 7.2, available: true,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c4ca469f-1774431858307.png",
  avatarAlt: 'Sarah Hamdi creator photo'
},
{
  id: 'sl-nadia', name: 'Nadia Cherif', handle: '@nadia.fashion', category: 'Fashion',
  momentum: 76, fitScore: 72, followers: '209K', engagement: 6.4, available: true,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c4ca469f-1774431858307.png",
  avatarAlt: 'Nadia Cherif creator photo'
}];


export default function ShortlistPanel() {
  const [removed, setRemoved] = useState<string[]>([]);
  const visible = shortlisted.filter((c) => !removed.includes(c.id));

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-700 text-foreground">Shortlist</h2>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">{visible.length} créateurs</span>
          <Link href="/find-a-creator" className="text-sm font-500 text-primary hover:text-primary/80 transition-colors">
            + Ajouter
          </Link>
        </div>
      </div>
      <div className="bg-card border border-border rounded-xl overflow-hidden">
        {visible.length === 0 ?
        <div className="flex flex-col items-center justify-center py-12">
            <Icon name="BookmarkIcon" size={32} className="text-muted-foreground mb-3" />
            <p className="text-sm font-600 text-foreground">Aucun créateur shortlisté</p>
            <p className="text-xs text-muted-foreground mt-1">Ajoutez des créateurs depuis la recherche</p>
            <Link href="/find-a-creator" className="mt-3 px-4 py-2 bg-primary text-primary-foreground text-sm font-600 rounded-lg hover:bg-primary/90 transition-all">
              Find a Creator
            </Link>
          </div> :

        <div className="divide-y divide-border">
            {visible.map((creator) =>
          <div key={creator.id} className="flex items-center gap-4 px-5 py-3 hover:bg-muted/30 transition-all group">
                <div className="w-10 h-10 rounded-full overflow-hidden border border-border flex-shrink-0">
                  <AppImage src={creator.avatar} alt={creator.avatarAlt} width={40} height={40} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-700 text-foreground truncate">{creator.name}</p>
                    <span className={`w-2 h-2 rounded-full flex-shrink-0 ${creator.available ? 'bg-positive' : 'bg-muted-foreground'}`} />
                  </div>
                  <p className="text-xs text-muted-foreground">{creator.category} · {creator.followers}</p>
                </div>
                <div className="hidden sm:flex items-center gap-3">
                  <MomentumBadge score={creator.momentum} size="sm" />
                  <FitScoreBadge score={creator.fitScore} size="sm" />
                  <span className="text-xs font-600 text-positive font-mono">{creator.engagement}%</span>
                </div>
                <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Link href="/creator-professional-page" className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground">
                    <Icon name="ArrowTopRightOnSquareIcon" size={14} />
                  </Link>
                  <button
                onClick={() => setRemoved((r) => [...r, creator.id])}
                className="p-1.5 rounded-lg hover:bg-negative/10 text-muted-foreground hover:text-negative"
                title="Retirer de la shortlist">
                
                    <Icon name="XMarkIcon" size={14} />
                  </button>
                </div>
              </div>
          )}
          </div>
        }
      </div>
    </div>);

}